<template>
  <div class="container" :class="{ 'label-disabled': isDisabled }">
    <input
      type="checkbox"
      class="tab-focused-btn"
      :id="index"
      :checked="checked"
      role="checkbox"
      :aria-checked="checked"
      :disabled="isDisabled"
      @change="(e) => handleInputChange(e)"
    />
    <label :for="index">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    index: Number,
    handleCheckbox: Function,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInputChange(e) {
      this.handleCheckbox && this.handleCheckbox(e.target.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
@import '@/styles/css/commonStyles.scss';

.container {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  cursor: pointer;
  color: #00203e;
  font-size: inherit;
  font-weight: 400;
  line-height: 20px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &.label-disabled {
    color: #b0b0b0;
    cursor: default;
  }
}

.container input {
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  height: 22px;
  width: 22px;
  background-color: #fff;
  border: 3px solid rgba(0, 0, 0, 0.22);
  border-radius: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.container input:checked {
  background-color: var(--bot-links-color);
}

.container input::after {
  content: '';
  position: absolute;
  top: 0.5px;
  left: 4.5px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.container input:checked::after {
  opacity: 1;
}
</style>
